import { CalendarDays, MapPin, Paperclip, UserRound } from "lucide-react";
import { JenisTag, StatusBadge } from "@/components/admin/JenisTag";
import { StatusStepper } from "@/components/progress/StatusStepper";
import { formatDateID } from "@/lib/format";

const Meta = ({ icon: Icon, children }) => (
  <span className="inline-flex items-center gap-1.5 text-sm text-slate-600">
    <Icon className="h-4 w-4 text-slate-400" /> {children}
  </span>
);

export const ComplaintSummary = ({ complaint: c, attachmentsCount, children }) => (
  <section className="space-y-5 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm sm:p-7" data-testid="complaint-summary">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <p className="font-mono text-sm font-bold text-emerald-700" data-testid="summary-ticket">#{c.ticket}</p>
        <div className="mt-2"><JenisTag jenis={c.jenis} /></div>
      </div>
      <span data-testid="summary-status"><StatusBadge status={c.status} /></span>
    </div>
    <StatusStepper status={c.status} />
    <div className="flex flex-wrap gap-x-5 gap-y-2">
      <Meta icon={UserRound}>{c.nama}</Meta>
      <Meta icon={MapPin}>{c.alamat}</Meta>
      <Meta icon={CalendarDays}>{formatDateID(c.tanggal, "d MMMM yyyy")}</Meta>
      {attachmentsCount > 0 && <Meta icon={Paperclip}>{attachmentsCount} lampiran</Meta>}
    </div>
    <p className="whitespace-pre-wrap break-words rounded-2xl bg-slate-50 p-4 text-sm leading-relaxed text-slate-700" data-testid="summary-detail">{c.detail}</p>
    {children}
  </section>
);
